import type { LanguageCode } from "@/hooks/useRestaurant";

/**
 * Map i18next language codes to the uppercase keys used in Firestore `_trans` blobs.
 * Tablet uses "en-US" but the PWA i18n is configured with "en" — both must resolve
 * to the same EN entry.
 */
const LANG_MAP: Record<string, LanguageCode> = {
  fr: "FR",
  cn: "CN",
  en: "EN",
  "en-US": "EN",
  it: "IT",
  es: "ES",
  de: "DE",
  pt: "PT",
  ja: "JA",
  ko: "KO",
};

/**
 * Champ traduit d'un document Firestore (`<field>_trans.<LANG>`), avec repli
 * sur le français. Une traduction vide ou composée d'espaces compte comme
 * absente : l'admin laisse souvent le champ vide, et `??` ne le couvrait pas.
 */
export const getTranslatedText = <T extends Record<string, any>>(
  item: T,
  field: string,
  language: string
): string => {
  const base = item[field] ?? "";
  if (language === "fr") return base;
  const langKey = LANG_MAP[language];
  const translated = langKey ? item[`${field}_trans`]?.[langKey] : undefined;
  return typeof translated === "string" && translated.trim() !== "" ? translated : base;
};
